export function getOutputDefaultCredits({ isMaster }, projectType) {
  if (!isMaster) {
    return 0;
  }

  return projectType === 'WEBINAR' ? 2 : 1;
}

export function getOutputCreditAmount(output, projectType) {
  const defaultCredits = getOutputDefaultCredits(output, projectType);

  const creditDeltaValue = output.creditDelta || 0;

  return defaultCredits + creditDeltaValue;
}

// Resolves an output's displayed credit values. In the read-only (customer)
// view, show each output's real Finance Production + Creative Services credits
// so the per-output breakdown reconciles to the subtotal; fall back to the
// legacy contract value when Finance hasn't loaded or in the editable view.
export function resolveOutputCredits({
  outputId,
  isMaster,
  outputCreditAmounts,
  financePerOutputCredits,
  hideCreditsModification,
  summaryCreativeServicesCredits = 0
}) {
  const addedCreditPerOutput = outputCreditAmounts ? outputCreditAmounts[outputId] : 0;
  const financeOutput = financePerOutputCredits ? financePerOutputCredits[outputId] : null;
  const useFinance = hideCreditsModification && financeOutput;

  const productionCredits = useFinance ? financeOutput.prodCredits : addedCreditPerOutput;
  // Creative-services credits are a project-level charge that belongs to the
  // master output. With Finance loaded, the master entry already carries them
  // (every other output reads 0). In the fallback (Finance not loaded yet),
  // attribute the project total to the master only — otherwise every output
  // repeats the full amount and the per-output breakdown no longer reconciles
  // to the project total.
  const creativeServicesCredits = useFinance ?
  financeOutput.creativeServiceCredits :
  isMaster ? summaryCreativeServicesCredits : 0;
  const totalCreditsWithCreativeServices = hideCreditsModification ?
  productionCredits + creativeServicesCredits :
  addedCreditPerOutput;

  return {
    addedCreditPerOutput,
    productionCredits,
    creativeServicesCredits,
    totalCreditsWithCreativeServices
  };
}
